module.exports = __webpack_public_path__ + "static/health-carousel-11480d621babfaed4018cd43561d0ec1.svg";